<article class="team-card" [class.set--active]="active">
  <fstr-image
    class="team-card__figure"
    [image]="image"
    other="trim.threshold=80"
    [alt]="title ? title : 'Team image'"
    [imageSizes]="[200, 400, 600, 800]"
  ></fstr-image>

  <header class="team-card__header" *ngIf="showBackground">
    <h1 class="team-card__title">
      <span class="team-card__title__rotate">{{ title }}</span>
    </h1>
    <app-text-shape *ngIf="active" [cssClasses]="'squiggle'" [type]="'standalone'" [autoplay]="true"></app-text-shape>
  </header>
</article>
